import React from 'react';

const TermsOfService = () => {
  return (
    <div className="policy-wrapper">
      <div className="policy-container">
        
        <div className="policy-header">
          <div className="header-icon-wrapper">
            <svg className="header-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h1 className="policy-title">Terms of Service</h1>
          <p className="policy-date">Last Updated: 2026-03-24</p>
        </div>

        <div className="policy-content">
          <section className="intro-section">
            <p>
              Welcome to <strong>AlarcTrade</strong>. These Terms of Service ("Terms") govern your access to and use of our website, products, and services. By accessing or using AlarcTrade, you agree to be bound by these Terms.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              1. User Accounts
            </h2>
            <p>
              To access certain features of AlarcTrade, you may need to register for an account. You agree to provide accurate, current, and complete information and to keep this information updated. You are responsible for safeguarding your password and for all activities that occur under your account.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
              </svg>
              2. Products and Pricing
            </h2>
            <p>
              We strive to display our products and their colors as accurately as possible. However, we cannot guarantee that your monitor's display of any color will be accurate. All descriptions of products or product pricing are subject to change at any time without notice, at our sole discretion. We reserve the right to discontinue any product at any time.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
              3. Orders and Payments
            </h2>
            <p>
              By placing an order on AlarcTrade, you warrant that you are legally capable of entering into binding contracts. We reserve the right to refuse or cancel any order for any reason, including limitations on quantities available for purchase, inaccuracies in product or pricing information, or problems identified by our fraud avoidance department.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
              4. Intellectual Property
            </h2>
            <p>
              All content included on the AlarcTrade platform, such as text, graphics, logos, images, and software, is the property of AlarcTrade or its content suppliers and protected by international copyright laws.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              5. Limitation of Liability
            </h2>
            <p>
              In no event shall AlarcTrade, its directors, employees, or affiliates be liable for any indirect, incidental, special, consequential or punitive damages arising out of or related to your use of the site or products purchased through the site.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              6. Changes to Terms
            </h2>
            <p>
              We reserve the right to update or modify these Terms at any time without prior notice. Your continued use of AlarcTrade following any changes constitutes your acceptance of the new Terms.
            </p>
          </section>

          <section className="policy-section">
            <div className="contact-card">
              <h2 className="contact-title">Have questions about our terms?</h2>
              <p className="contact-subtitle">If you have any questions or concerns, please reach out to us:</p>
              <div className="contact-details">
                <div className="contact-item">
                  <span className="label">Email:</span>
                  <a href="mailto:contact@alarctrade.com" className="text-link font-medium">contact@alarctrade.com</a>
                </div>
                {/* <div className="contact-item">
                  <span className="label">Phone:</span>
                  <span className="address-text">[Phone Number]</span>
                </div> */}
                <div className="contact-item">
                  <span className="label">Address:</span>
                  <span className="address-text">C/O KAWOSHE ACHUMI, DOPN
CHEKIYE, BLOCK 5. AGASA 4TH MILE, DIMAPUR
797115</span>
                </div>
              </div>
            </div>
          </section>
        </div>

      </div>
    </div>
  );
};

export default TermsOfService;